/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { AnalyticsProvider } from '../AnalyticsProvider';

export default class AppsFlyerProvider implements AnalyticsProvider {
  name = 'appsFlyer';

  async track(eventName: string, properties?: Record<string, unknown>): Promise<void> {
    // @ts-ignore
    await window.AF('pba', 'event', {
      eventType: 'EVENT',
      eventValue: properties,
      eventName: eventName,
    });
  }
}
